import getGraphQlClient from '~graphql/getGraphQlClient';
import {
  FETCH_FEATURES,
  FETCH_FEATURES_PREFERENCES,
} from '../queries/features';
import { onErrorShowMessage } from '~src/errors';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { findOrgModules } from './findOrgModules';

export const fetchDisabledOrgFeatures = async (orgId, plan) => {
  try {
    const graphQlClient = await getGraphQlClient();

    let where = {
      AND: [
        { products: { contains: 'giotto' } },
        { default: { notEqualTo: true } },
      ],
    };
    if (!plan || plan === 'module') {
      const orgModules = await findOrgModules(orgId);
      const enabledModuleIds = (orgModules || [])
        .map((item) => item.module_pointer?.objectId)
        .filter(Boolean);

      if (enabledModuleIds.length > 0) {
        where.AND.push({
          module_pointer: {
            haveNot: {
              objectId: {
                in: enabledModuleIds,
              },
            },
          },
        });
      }
    } else {
      where.AND.push({ plans: { notEqualTo: plan } });
    }

    const responseDisabledByPlanOrModule = await graphQlClient.query({
      variables: {
        where,
      },
      query: FETCH_FEATURES,
    });

    const disabledByPlan = await unmarshalGraphqlResponse(
      responseDisabledByPlanOrModule.data,
      'findFeatures'
    ).edges;

    const wherePreferences = {
      AND: [
        { org_pointer: { have: { objectId: { equalTo: orgId } } } },
        { user_pointer: { exists: false } },
        { product: { equalTo: 'giotto' } },
      ],
    };

    const responsePreferences = await graphQlClient.query({
      variables: {
        where: wherePreferences,
      },
      query: FETCH_FEATURES_PREFERENCES,
    });

    let preferences = await unmarshalGraphqlResponse(
      responsePreferences.data,
      'features_preferences'
    ).edges;

    // Apply preferences in the same spirit as Eterno's features.php
    // Sort so enabled overrides (disabled=false) are applied first
    preferences = preferences.sort((a, b) => {
      if (a.disabled === b.disabled) return 0;
      return a.disabled ? 1 : -1; // false first
    });

    const disabledFeatures = [...disabledByPlan];

    for (const pref of preferences) {
      const key = pref.key;
      const parts = key.split('.');
      const root = parts[0];
      const action = parts[1];

      if (pref.disabled === false) {
        // Remove matching disabled entries
        if (action === 'show') {
          // Remove any disabled feature starting with the same root
          for (let i = disabledFeatures.length - 1; i >= 0; i--) {
            if (
              disabledFeatures[i].name &&
              disabledFeatures[i].name.startsWith(root)
            ) {
              disabledFeatures.splice(i, 1);
            }
          }
        } else {
          const idx = disabledFeatures.findIndex((f) => f.name === key);
          if (idx !== -1) disabledFeatures.splice(idx, 1);
        }
      } else if (pref.disabled === true) {
        // Force-disable: ensure presence
        if (!disabledFeatures.some((f) => f.name === key)) {
          disabledFeatures.push({ name: key });
        }
      }
    }

    return disabledFeatures;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};

export const fetchDisabledUserFeatures = async (orgId, userId) => {
  try {
    const graphQlClient = await getGraphQlClient();
    const where = {
      AND: [
        { org_pointer: { have: { objectId: { equalTo: orgId } } } },
        { user_pointer: { have: { objectId: { equalTo: userId } } } },
        { product: { equalTo: 'giotto' } },
      ],
    };

    const response = await graphQlClient.query({
      variables: {
        where,
      },
      query: FETCH_FEATURES_PREFERENCES,
    });

    const disabledUserFeatures = unmarshalGraphqlResponse(
      response.data,
      'features_preferences'
    ).edges;

    return disabledUserFeatures;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
